<template>
  <v-dialog v-model="dialogShowQRCode" persistent max-width="500px">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai" style="white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;">
           <span class="headline CSChatThai" >
              <v-icon color="white">group</v-icon>&nbsp;&nbsp;{{$t('Dialog.group.group')}} {{detail.group_name}}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">
        <v-container grid-list-md>
          <v-layout wrap >
                  <v-flex sm12 md12 lg12 xl12 >
                      <div >
                        <p style="text-align: center;">
                          <qrcode :value="tokenuserQR" style="margin: 0 !important; height: 220px;width: 220px;padding: 5px;border: 3px solid; border-radius: 10px;" id="downloadqrgroup"></qrcode>
                         <!--  <vue-qr logoSrc="/static/img/icons/logoonechat.png" :text="tokenuserQR" :size="200" id="downloadqrgroup" :dotScale="1" :logoScale="100"></vue-qr> -->
                        </p> 
                        <p>{{$t('Dialog.group.detailQrcode')}}
                        <a href="#" class="button" id="btn-download" :download="'qrcode_group_' + detail.group_name + '.png'" @click="loadqr()">{{$t('AnswerQuestion.download')}}</a></p>
                      </div>
                  </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
Vue.component(VueQrcode.name, VueQrcode)

export default {
  props: {'dialogShowQRCode': false, detail: {}},
  data: () => ({
    tokenuserQR: ''
  }),
  methods: {
    closeDialog () {
      this.$emit('closeShowQRCodeGroup', false)
    },
    loadqr () {
      var cnvs = document.getElementById('downloadqrgroup')
      var button = document.getElementById('btn-download')
      var dataURL = cnvs.toDataURL('image/png')
      // console.log(cnvs)
      button.href = dataURL
    }
  },

  computed: {
  },
  watch: {
    detail () {
      // console.log(this.detail.group_id)
      // this.tokenuserQR = 'https://com.oneplatform.android.onechat.group/u/' + btoa(this.detail.group_id)
      this.tokenuserQR = process.env.APIQRcode + '/qrcode/group?id=' + btoa(this.detail.group_id)
      // console.log(this.tokenuserQR)
      // var token = Decode.decodeToken(this.$cookie.get('tokenuser'))
      // this.tokenuserQR = process.env.APIQRcode + '/qrcode/friend?id=' + btoa(token)
    }
  }
}
</script>
<style type="text/css" scoped>

.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
/*.application .theme--light.input-group:not(.input-group--error) label, .theme--light .input-group:not(.input-group--error) label {
  color: #5ed1ff !important;
}*/
</style>


// WEBPACK FOOTER //
// src/components/chat/dialog/manage_group/ShowQRCodeGroupDialog.vue